import { render, staticRenderFns } from "./swedbank-script-card.vue?vue&type=template&id=2c7e6e79&"
import script from "./swedbank-script-card.vue?vue&type=script&lang=js&"
export * from "./swedbank-script-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports